<template>
  <!-- 全局的登录弹窗 -->
  <el-dialog
    :append-to-body="true"
    class="login-dialog"
    :close-on-click-modal="false"
    :lock-scroll="true"
    :modal-append-to-body="true"
    :show-close="false"
    top="calc(50vh - 185px)"
    :visible.sync="$store.state.loginDialogVisible"
    width="650px"
    @close="close"
  >
    <div class="login-box">
      <el-button
        class="close"
        icon="el-icon-close"
        type="text"
        @click="close"
      />
      <div class="lr">
        <div class="left">
          <div class="lr-title">手机号登录/注册</div>
          <el-form
            ref="form"
            class="login-form"
            label-width="0"
            :model="loginForm"
          >
            <el-form-item>
              <el-input
                v-model="loginForm.phone"
                class="phone"
                placeholder="请输入手机号"
              >
                <el-select
                  v-model="loginForm.country"
                  class="country-select"
                  slot="prepend"
                >
                  <el-option
                    v-for="(c, index) in countryList"
                    :key="index"
                    :label="`+${c.area_code}`"
                    :value="c.code"
                    >{{ c.name_cn }} +{{ c.area_code }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="loginForm.code"
                class="codeinput"
                placeholder="请输入验证码"
              >
                <el-button
                  slot="append"
                  class="yzm-button"
                  :disabled="yzmDisabled"
                  :loading="yzmLoading"
                  type="text"
                  @click="getYzm()"
                  >{{ yzmText }}</el-button
                >
              </el-input>
            </el-form-item>

            <el-form-item class="buttons">
              <el-button
                :loading="loginLoading"
                type="primary"
                @click="goOnLogin"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
          <div v-if="treatys.length > 0" class="treatys">
            <el-checkbox v-model="agreeChecked" class="checked" />
            <span class="text">
              <span>我同意</span>
              <span v-for="(i, k) in treatys" :key="k">
                {{ k === treatys.length - 1 ? '及' : '' }}
                <a class="link" @click="openUrl(i.page.path)"
                  >《{{ i.name }}》</a
                >
              </span>
            </span>
          </div>
        </div>
        <div class="right">
          <div class="lr-title">微信扫码登录</div>
          <div class="sub-title">使用「微信APP」扫一扫登录</div>
          <div class="wechat-code">
            <div id="wxlogin_container"></div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getCountryList } from '@/network/request'
import { getPageData, goLogin, getYzm } from '@/network/request'
export default {
  name: 'LoginDialog',
  data() {
    return {
      treatys: [],
      agreeChecked: false, // 复选框控制
      usePassword: false,
      wechatToken: '',
      loginForm: {
        country: 'CN',
        phone: '',
        code: '',
        paddword: '',
      },
      loginLoading: false,

      // 获取验证码
      yzmDisabled: false,
      yzmLoading: false,
      yzmText: '获取验证码',
      yzmTimer: null,

      // 国家地区列表
      countryList: [],
      countryAreas: {},
    }
  },
  computed: {
    loginDialogVisible() {
      return this.$store.state.loginDialogVisible
    },
    countryPre() {
      let area_code = this.countryAreas[this.loginForm.country] || ''
      return area_code ? `+${area_code}` : ''
    },
    formatPhone() {
      return this.loginForm.phone
        ? `${this.countryPre}${this.loginForm.phone}`
        : ''
    },
  },
  watch: {
    loginDialogVisible(e) {
      if (e) {
        this.loadWxLoginHandel()
        window.setWechatToken = this.setWechatToken
        window.loginSuccess = this.loginSuccess
      } else {
        delete window.setWechatToken
        delete window.loginSuccess

        this.$nextTick(() => {
          // 重置数据
          const resetData = this.$options.data()
          this.agreeChecked = resetData.agreeChecked
          this.wechatToken = resetData.wechatToken
          this.loginForm = resetData.loginForm
          this.yzmDisabled = resetData.yzmDisabled
          this.yzmLoading = resetData.yzmLoading
          this.yzmText = resetData.yzmText
          if (this.yzmTimer) {
            clearInterval(this.yzmTimer)
          }
        })
      }
    },
  },
  created() {
    this.getPageData()
    this.loadCountryList()
  },
  methods: {
    close() {
      this.$store.commit('loginDialogClose')
    },
    // 读取登录页数据
    getPageData() {
      getPageData({ alias: 'LOGIN' }).then((res) => {
        this.treatys = res.data.result.params.treatys || []
      })
    },
    // 获取国家列表
    async loadCountryList() {
      // 如果本地存储中有职业列表，则不走接口
      if (localStorage.getItem('option-countries')) {
        this.countryList = JSON.parse(localStorage.getItem('option-countries'))
      } else {
        const res = await getCountryList()
        // console.log(res.data.result)
        this.countryList = res.data.result
        localStorage.setItem(
          'option-countries',
          JSON.stringify(res.data.result)
        )
      }
      this.countryAreas = {}
      this.countryList.forEach((i) => {
        this.countryAreas[i.code] = i.area_code
      })
    },

    loadWxLoginHandel() {
      this.$nextTick(() => {
        /* eslint-disable */
        const redirect_uri =
          'https://server.xbeduc.com/notice/oauth/wechat/back/pc'
        const backurl = this.$common.getlocalBaseUrl() + '/wxback'
        const userToken = localStorage.getItem('user-token') || ''
        new WxLogin({
          self_redirect: true,
          id: 'wxlogin_container',
          appid: 'wxb7da7912740a8270',
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent(
            `${redirect_uri}?&backurl=${backurl}&user_token=${userToken}`
          ),
          state: '',
          style: 'black',
          href: this.$common.getResourceUrl('pcweb/wx-login-style-dialog.css'),
        })
        /* eslint-disable */
      })
    },
    // 获取验证码
    async getYzm() {
      let phone = this.formatPhone
      if (!phone) {
        this.$message.error('请输入手机号')
        return false
      }

      this.yzmLoading = true
      this.yzmText = '正在发送'
      const res = await getYzm({
        phone,
        country: this.loginForm.country,
      }).catch((e) => {
        // 频繁时会携带剩余秒数返回
        this.setCodeTime(e.data.code === 20001 ? e.data.result.surplus : 0)
      })
      this.yzmLoading = false
      if (res) this.setCodeTime(res.data.result.surplus || 0)
    },
    // 获取验证码倒计时
    setCodeTime(time) {
      console.info(time)
      if (time > 0) {
        this.yzmDisabled = true
        this.yzmText = time + ' s'
        this.yzmTimer = setInterval(() => {
          time--
          if (time <= 0) {
            this.yzmDisabled = false
            this.yzmText = '重新获取'
            clearInterval(this.yzmTimer)
          } else {
            this.yzmText = time + ' s'
          }
        }, 1000)
      } else {
        this.yzmDisabled = false
        this.yzmText = '重新获取'
      }
    },

    // 登录接口
    async goOnLogin() {
      if (this.agreeChecked) {
        let phone = this.formatPhone
        if (!phone) {
          this.$message.error('请输入手机号')
          return false
        }
        const formData = { phone, country: this.loginForm.country }
        if (this.usePassword) {
          if (!this.loginForm.password) {
            this.$message.error('请输入登录密码')
            return false
          } else {
            formData.password = this.loginForm.password
          }
        } else {
          if (!this.loginForm.code) {
            this.$message.error('请输入短信验证码')
            return false
          } else {
            formData.code = this.loginForm.code
          }
        }
        if (this.wechatToken) formData.wechatToken = this.wechatToken
        this.loginLoading = true
        let res = await goLogin(formData).catch(() => {})
        this.loginLoading = false
        if (res) this.loginSuccess()
      } else {
        this.$message.error('请阅读并同意用户服务协议及隐私政策')
      }
    },

    openUrl(url) {
      window.open(url)
    },
    // 设置wechatToken
    setWechatToken(wechatToken) {
      this.wechatToken = wechatToken
    },
    // 登陆成功
    async loginSuccess() {
      await this.$store.dispatch('setUser')
      await this.$store.dispatch('loginNext')
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
#wxlogin_container {
  text-align: center;
  margin-top: 30px;
  height: 210px;
  overflow: hidden;
  ::v-deep iframe {
    width: 100%;
    height: 100%;
  }
}

.treatys {
  text-align: center;
  margin-top: 17px;
  line-height: 18px;
  .text {
    font-size: 12px;
    margin-left: 10px;
    color: #999999;
    .link {
      color: #37a6ff;
      cursor: pointer;
    }
  }
}
.login-dialog {
  ::v-deep .el-dialog {
    background: none;
  }
  ::v-deep .el-dialog__header {
    display: none;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }

  .login-box {
    position: relative;
    border-radius: 15px;
    background: #fff;
    padding: 40px 0;
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      padding: 2px;
      ::v-deep .el-icon-close {
        font-size: 22px;
        color: #979797;
        font-weight: 500;
      }
    }

    .lr {
      display: flex;
    }
    .left {
      flex: 1;
      border-right: 1px solid #e6e6e6;
      padding: 0 36px;

      .login-form {
        margin-top: 30px;

        ::v-deep .el-form-item__content {
          background: #f7f7f7;
          border-radius: 15px;
          line-height: 50px;
          .el-input__inner {
            font-size: 16px;
            background: none;
            border: none;
            line-height: 50px;
            height: 50px;
          }
          .el-input__inner {
            padding: 0 19px;
          }
        }

        .phone {
          ::v-deep > .el-input__inner {
            padding-left: 10px;
          }

          ::v-deep .el-input-group__prepend {
            border: none;
            background: none;
            border-radius: 15px;
            .country-select {
              width: 90px;
              .el-input__inner {
                background: none;
                text-align: left;
                font-size: 18px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #202020;
              }
            }
          }
        }

        .codeinput {
          ::v-deep .el-input-group__append {
            border: none;
            background: none;
            border-radius: 15px;
          }

          .yzm-button {
            height: 50px;
            line-height: 50px;
            background: none;
            color: #1296ff;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1296ff;
            padding: 0 16px;
          }
        }

        .buttons {
          margin-bottom: 3px;
          ::v-deep .el-form-item__content {
            background: none !important;
            .el-button {
              display: block;
              border: none;
              width: 100%;
              height: 42px;
              line-height: 42px;
              background: #1296ff;
              border-radius: 6px;
              padding: 0;

              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
            }
          }
        }
      }
    }
    .right {
      width: 294px;
      padding: 0 36px;

      .sub-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #828282;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;
      }
    }

    .lr-title {
      padding-top: 3px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #202020;
      line-height: 25px;
      text-align: center;
    }
  }
}
</style>
